<template>
  <div>
    <div class="pa-1">
      <v-card>
        <v-card-title>{{ $t('Active Users by Date') }}</v-card-title>

        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <template v-if="activeuserbydateSeries">
          <apexchart
            ref="activeuserbydate"
            type="area"
            height="350"
            :options="activeuserbydate"
            :series="activeuserbydateSeries"
          ></apexchart>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

import moment from 'moment'

import VueApexCharts from 'vue-apexcharts'

import DashboardGraphLoading from './DashboardGraphLoading'

export default {
  props: ['loading', 'selectedDate', 'filter', 'com7pageid'],
  data: function () {
    return {
      activeuserbydateSeries: undefined,
      activeuserbydate: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: 'Users'
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted: function () {
    this.initData()
  },
  methods: {
    initData() {
      if (this.selectedBot.status) this.getActiveUserByDate()
      else {
        this.$nextTick().then(() => {
          this.activeuserbydateSeries = [
            { name: this.$t('active users'), data: [[moment().format('YYYY-MM-DDT00:00:00'), 0]] },
            { name: this.$t('new users'), data: [[moment().format('YYYY-MM-DDT00:00:00'), 0]] },
            {
              name: this.$t('existing users'),
              data: [[moment().format('YYYY-MM-DDT00:00:00'), 0]]
            }
          ]
          this.$emit('onLoaded', { loading: false, data: null })
        })
      }
    },
    getActiveUserByDate: function () {
      let vm = this
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      vm.$emit('onLoaded', { loading: true, data: null })
      var selectedApi = 'getDashboardActiveUserByDate'
      if (['ticket2', 'studio7'].includes(this.$store.state.selectedBot.theme)) {
        selectedApi = 'getcom7pagereport_activeusers_bydate'
        data.pageid = this.com7pageid ? this.com7pageid : this.$store.state.selectedBot.pageid
      }
      api[selectedApi](data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$emit('onLoaded', { loading: false, data: null })
          return
        }
        let data = []
        let data2 = []
        let data3 = []

        let max = 0

        $.each(response.data, function (index, val) {
          data.push([
            moment(val['date']).format('YYYY-MM-DDT00:00:00'),
            parseInt(val['activeusers'])
          ])
          data2.push([moment(val['date']).format('YYYY-MM-DDT00:00:00'), parseInt(val['newusers'])])
          data3.push([
            moment(val['date']).format('YYYY-MM-DDT00:00:00'),
            parseInt(val['activeusers']) - parseInt(val['newusers'])
          ])

          if (max < parseInt(val['activeusers'])) {
            max = parseInt(val['activeusers'])
          }

          if (max < parseInt(val['newusers'])) {
            max = parseInt(val['newusers'])
          }
        })

        vm.activeuserbydateSeries = [
          { name: vm.$t('active users'), data: data },
          { name: vm.$t('new users'), data: data2 },
          { name: vm.$t('existing users'), data: data3 }
        ]

        vm.$nextTick(function () {
          if (vm.$refs.activeuserbydate) {
            vm.$refs.activeuserbydate.updateOptions({
              yaxis: {
                max: max + 5
              }
            })
          }
          vm.$emit('onLoaded', { loading: false, data: vm.activeuserbydateSeries })
        })
      })
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getActiveUserByDate()
      },
      deep: true
    },
    filter: function () {
      this.getActiveUserByDate()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/ActiveUserByDate.vue